import { z } from 'zod';
import { c } from '../../contract';
import { CommonProgressItem } from '../../types';

export const promoCodeRouter = c.router(
  {
    applyBookPromoCode: {
      summary: 'Apply a book promo code',
      method: 'POST',
      path: '/book/apply',
      body: z.object({
        seriesId: z.string(),
        promoCode: z.string(),
      }),
      responses: {
        200: z.object({
          progress: CommonProgressItem,
        }),
        400: z.object({
          error: z.string(),
          errorCode: z.enum(['promo-code-not-exist', 'promo-code-used']),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
    validateBookPromoCode: {
      summary: 'Validate a book promo code',
      path: '/book/validate',
      method: 'POST',
      body: z.object({
        code: z.string(),
      }),
      responses: {
        200: z.object({
          isValid: z.boolean(),
        }),
        400: z.object({
          isValid: z.boolean(),
          error: z.string(),
        }),
        500: z.object({
          isValid: z.boolean(),
          error: z.string(),
        }),
      },
    },
    getAppliedBookPromoCodes: {
      summary: 'Get applied book promo codes',
      path: '/book/get',
      method: 'GET',
      responses: {
        200: z.object({
          promoCodes: z.array(
            z.object({
              code: z.string(),
              seriesId: z.string().nullable(),
            }),
          ),
        }),
        400: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/promo-codes' },
);
